export default __webpack_public_path__ + "static/media/colour.751fa337.png";